import { connect } from 'react-redux'
import ServiceViewServiceDays from '../../components/services/view/ServiceViewServiceDays'
import { fetchServiceDays } from '../../state/actions/services/index'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const serviceId = ownProps.serviceId
  const service = state.service.items[serviceId]
  return {
    serviceId,
    orgId: state.organizations.currentOrgId,
    holidaysList: state.serviceEdit.holidaysSection.list,
    workingHoursList: state.serviceEdit.workingHoursSection.list,
    isAllDaysActive: service ? service.isAllDaysActive : true
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onComponentMount: (serviceId: string, orgId: string) => {
      dispatch(fetchServiceDays(serviceId, orgId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceViewServiceDays)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewServiceDays.ts